import { Actions, Badge, Image, ToggleActiveStatus } from "@";
import { popUpShowingSectionOptions } from "../utils/options";
// Component for rendering table actions
export const TableActions = ({
  row,
  deleteHandler,
  ToggleActive,
  handlerEdit,
}) => {
  return (
    <Actions notShow row={row} edit={handlerEdit} delete={deleteHandler}>
      <ToggleActiveStatus row={row} click={ToggleActive} />
    </Actions>
  );
};

// Define table columns configuration
export const tableColumns = [
  {
    name: "",
    cell: ({ imageUrl }) => <Image size={96} src={imageUrl} />,
  },
  {
    name: "الرابط",
    selector: ({ url }) => url,
    grow: 2,
  },
  {
    name: "عرض في",
    grow: 2,
    cell: ({ section }) => (
      <div className="flex flex-col items-center justify-center gap-1 md:flex-row md:gap-3">
        {
          popUpShowingSectionOptions.filter((el) => el.value === section)[0]
            ?.title
        }
      </div>
    ),
  },
  {
    name: "الحالة ",
    cell: ({ isActive }) => (
      <Badge
        title={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "green" : "red"}
      />
    ),
  },
];
